// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"6e4a00f7","232":"eaf9650e","237":"f39026cd","526":"d3d1dc65","872":"fee92302"}[chunkId] + ".chunk.js";
};